import $ from 'jquery';
import * as pdfjsLib from 'pdfjs-dist';

const INITIAL_SCALE = 1;

$(function() {
    let $fileViewers = $('.pdf-viewer');

    pdfjsLib.GlobalWorkerOptions.workerSrc = window.Buckle.urls.theme + '/public/js/pdf.worker.js';

    if ($fileViewers.length) {
        $fileViewers.each(function() {
            let $viewer = $(this);

            if (!$viewer.data('url')) {
                return;
            }

            pdfjsLib.getDocument($viewer.data('url')).then(function(document) {
                let canvas = $viewer.children('canvas').get(0);

                $viewer.data('instance', {
                    document: document,
                    canvas: canvas,
                    context: canvas.getContext('2d'),
                    pageNumber: 1,
                    pageNumberPending: null,
                    pageRendering: false,
                });

                renderPage(1, $viewer.data('instance'), $viewer.find('.current'));

                $viewer.find('.total').text(document.numPages);
                $viewer.removeClass('pdf-viewer--loading');
            }).catch(error => console.warn(error));

            $viewer.on('click', '.pdf-viewer__navigation__item--previous', function() {
                previousPageTrigger($viewer.data('instance'), $viewer.find('.current'));
            });

            $viewer.on('click', '.pdf-viewer__navigation__item--next', function() {
                nextPageTrigger($viewer.data('instance'), $viewer.find('.current'));
            });

            $viewer.on('click', '.pdf-viewer__fullscreen', function() {
                let _instance = $viewer.data('instance');

                $viewer.get(0).requestFullscreen();

                setTimeout(function() {
                    $viewer.addClass('pdf-viewer--fullscreen');
                    renderPage(_instance.pageNumber, _instance, $viewer.find('.current'));
                }, 10);
            });

            $viewer.on('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(event) {
                let enteredFullscreenMode = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;

                if (!enteredFullscreenMode) {
                    $viewer.removeClass('pdf-viewer--fullscreen');
                }

                renderPage(1, $viewer.data('instance'), $viewer.find('.current'));
            });
        });
    }
});

const renderPage = (number, instance, $currentPage) => {
    instance.pageRendering = true;

    instance.document.getPage(number).then(function(page) {
        let viewport = page.getViewport(INITIAL_SCALE);
        let scale = $currentPage.parents('.pdf-viewer').width() / viewport.width;

        viewport = page.getViewport(scale);

        instance.canvas.height = viewport.height;
        instance.canvas.width = viewport.width;

        let renderTask = page.render({
            canvasContext: instance.context,
            viewport: viewport,
        });

        renderTask.promise.then(function() {
            instance.pageRendering = false;

            if (instance.pageNumberPending !== null) {
                renderPage(instance.pageNumberPending);
                instance.pageNumberPending = null;
            }
        }).catch(error => console.warn(error));

        if ($currentPage !== null) {
            $currentPage.text(number);
        }
    });
};

const queueRenderPage = (number, instance, $currentPage) => {
    if (instance.pageRendering) {
        instance.pageNumberPending = number;
    } else {
        renderPage(number, instance, $currentPage);
    }
};

const previousPageTrigger = (instance, $currentPage) => {
    if (instance.pageNumber <= 1) {
        return;
    }

    instance.pageNumber--;
    queueRenderPage(instance.pageNumber, instance, $currentPage);
};

const nextPageTrigger = (instance, $currentPage) => {
    if (instance.pageNumber >= instance.document.numPages) {
        return;
    }

    instance.pageNumber++;
    queueRenderPage(instance.pageNumber, instance, $currentPage);
};



// WEBPACK FOOTER //
// ./resources/assets/scripts/components/PDFViewer.js